import { clsx } from "clsx";
import type { ReactElement, ReactNode } from "react";

import { Text } from "@primitives/Text";

import styles from "./AskQuestionDialog.module.css";

interface ComposeRowProps {
  readonly label: string;
  /** Set when the label is a `<label>` for an input. */
  readonly htmlFor?: string;
  /** Set when the label is referenced by `aria-labelledby`. */
  readonly labelId?: string;
  readonly className?: string | undefined;
  readonly trailing?: ReactNode;
  readonly children: ReactNode;
}

/** One inline-label row of the compose sheet ("To", "From"). */
export function ComposeRow({
  label,
  htmlFor,
  labelId,
  className,
  trailing,
  children,
}: ComposeRowProps): ReactElement {
  return (
    <div className={clsx(styles.row, className)}>
      {htmlFor !== undefined ? (
        <Text
          as="label"
          role="bodySm"
          tone="muted"
          htmlFor={htmlFor}
          className={clsx(styles.rowLabel)}
        >
          {label}
        </Text>
      ) : (
        <Text
          as="span"
          role="bodySm"
          tone="muted"
          className={clsx(styles.rowLabel)}
          {...(labelId !== undefined ? { id: labelId } : {})}
        >
          {label}
        </Text>
      )}
      {children}
      {trailing !== undefined && <span className={styles.rowTrailing}>{trailing}</span>}
    </div>
  );
}
